import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Input,
  Label,
  Loader,
} from "@coval/ui"

interface WorkspaceRenameDialogProps {
  open: boolean
  name: string
  error: string
  isPending: boolean
  isReady: boolean
  onOpenChange: (open: boolean) => void
  onNameChange: (value: string) => void
  onConfirm: () => void
}

export function WorkspaceRenameDialog(props: WorkspaceRenameDialogProps) {
  const {
    open,
    name,
    error,
    isPending,
    isReady,
    onOpenChange,
    onNameChange,
    onConfirm,
  } = props
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rename workspace</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
              <Label htmlFor="rename-workspace-name">Workspace name</Label>
              <Input
                id="rename-workspace-name"
                value={name}
                onChange={(e) => onNameChange(e.target.value)}
                disabled={isPending}
              />
            </div>
            {error && (
              <div role="alert" className="text-xs text-destructive">
                {error}
              </div>
            )}
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onConfirm()}
            disabled={isPending || !isReady}
            data-testid="workspace-rename-confirm"
          >
            {isPending ? (
              <span className="inline-flex items-center gap-2">
                <Loader size="sm" />
                Saving...
              </span>
            ) : (
              "Save"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
